import mixpanel from 'mixpanel-browser';

const init = () => {
  const mixpanelToken = Env.MIXPANEL_TOKEN;
  if (mixpanelToken && mixpanelToken !== '') {
    mixpanel.init(mixpanelToken, {
      api_host: 'https://api-eu.mixpanel.com',
      ignore_dnt: true,
      debug: false,
    });
  }
};

const checkAndRun = (fn: () => void) => {
  try {
    fn();
  } catch (e) {
    init();
    fn();
  }
};

const sendEventLogin = (properties?: any) => {
  checkAndRun(() => mixpanel.track('User Login', properties || null));
};

const sendEventLogout = (properties?: any) => {
  checkAndRun(() => mixpanel.track('User Logout', properties || null));
  mixpanel.reset();
};

const sendEvent = (name: string, properties?: any) => {
  checkAndRun(() => mixpanel.track(name, properties || null));
};

const recordPageView = () => {
  checkAndRun(() => mixpanel.track_pageview());
};

const identifyUser = (id: string) => {
  checkAndRun(() => mixpanel.identify(id));
};

export const Analytics = {
  init,
  sendEvent,
  recordPageView,
  identifyUser,
  sendEventLogin,
  sendEventLogout,
};
